import Clarity from "@microsoft/clarity";

import { ClarityTypes } from "utils/types/Firebase";

export const useClarity = () => {
  // function to initialize clarity
  const initializeClarity = (clarityDetails: ClarityTypes): void => {
    // verify clarity is imported
    if (Clarity && typeof Clarity.init === "function") {
      // initialize clarity
      Clarity.init(clarityDetails?.projectId);
    }
  };

  return { initializeClarity };
};
